import React from 'react';
import PropTypes from 'prop-types';

import styles from './Forms.scss';

import InputField from './InputFields/InputFieldV2';
import FormFieldAddOn from './FormFieldAddOn';

import pressedKeyValidator from '../../lib/pressedKeyValidator';

const VALID_CHARS = '0123456789.';

function FormFieldPercentage({ inputProps, children }) {
    return (<div className={styles['form-field-percentage']}>
        <InputField
            {...inputProps}
            type="text"
            name="sample_size"
            maxLength="5"
            onKeyPress={(e) => {
                pressedKeyValidator(e, VALID_CHARS);
            }}
            percentage="true"
        />
        <span
            className={styles[`icon-percentage${inputProps.status ? `-${inputProps.status}` : ''}`]}
        />
        <FormFieldAddOn>
            {children}
        </FormFieldAddOn>
    </div>)
}

FormFieldPercentage.propTypes = {
    inputProps: PropTypes.shape({
        value: PropTypes.any.isRequired,
        onChange: PropTypes.func.isRequired,
        status: PropTypes.any,
    }).isRequired,
    children: PropTypes.any.isRequired,
};

export default FormFieldPercentage;
